import React from 'react';
import './Navbar.css';
import logo from '../assets/logo.png';

const Navbar = () => {
  return (
    <header className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src={logo} alt="Logo" />
        </div>
        <nav className="navbar-links">
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/features">Our Team</a></li>
            <li><a href="/careers">Explore Careers</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/feedback">Feedback</a></li>
            <li><a href="/About">About</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Navbar;
